/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import './filteroptions.scss';

function FilterOptions({ setCategory, setPriceRange, resetFilters }) {
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const [showAll, setShowAll] = useState(true); // State to track if "Sve" is selected

  const categories = {
    'AKCIJA!' : ['AKCIJA!'],
    'MOVI' : ['MOVI'],
    'Koža': ['Goveđa koža', 'Ovčija koža', 'Svinjska koža', 'Koža na kilogram'],
    'Lepila': ['Jednokomponentna(Žuta)', 'Dvokomponentna(Bela)', 'Dodatna Oprema'],
    'Guma': ['Poluđonovi', 'Pete', 'Eva Program', 'VIBRAM', 'SVIG', 'Ortopedski program', 'Đonovi'],
    'Hemija': ['Farbe', 'Perila za đonove'],
    'Galanterija': ['Galanterija'],
    'Alati': ['Alati'],
    'Kozmetika': ['Kreme'],
    'Mašine': ['Mašine'],
    'Komponente': ['Komponente']
  };

  useEffect(() => {
    const min = minPrice ? parseInt(minPrice, 10) : 0;
    const max = maxPrice ? parseInt(maxPrice, 10) : Infinity;
    setPriceRange([min, max]);
  }, [minPrice, maxPrice, setPriceRange]);

  const handleMinPriceChange = (e) => {
    setMinPrice(e.target.value);
  };

  const handleMaxPriceChange = (e) => {
    setMaxPrice(e.target.value);
  };

  const handleResetFilters = () => {
    setMinPrice('');
    setMaxPrice('');
    setSelectedCategory('');
    setSelectedSubcategory('');
    resetFilters();
    setShowAll(true); // Reset "Sve" button
  };

  const handleCategoryClick = (category) => {
    setShowAll(false); // Deselect "Sve" button when a category is selected
    if (selectedCategory === category) {
      setSelectedCategory('');
      setSelectedSubcategory('');
      setCategory('');
      setShowAll(true);
    } else {
      setSelectedCategory(category);
      setSelectedSubcategory('');
      setCategory(categories[category]);
    }
  };

  const handleSubcategoryClick = (subcategory) => {
    if (selectedSubcategory === subcategory) {
      setSelectedSubcategory('');
      setCategory(categories[selectedCategory]);
    } else {
      setSelectedSubcategory(subcategory);
      setCategory([subcategory]);
    }
  };

  const handleShowAllClick = () => {
    setMinPrice('');
    setMaxPrice('');
    setSelectedCategory('');
    setSelectedSubcategory('');
    setCategory('');
    resetFilters();
    setShowAll(true); // Select "Sve" button
  };

  return (
    <div className="filter-options">
      <button
        onClick={handleShowAllClick}
        className={showAll ? 'selected-main' : ''}
      >
        Sve
      </button>
      <div className="dropdown">
        {Object.keys(categories).map((category) => (
          <div key={category}>
            <button
              onClick={() => handleCategoryClick(category)}
              className={selectedCategory === category ? 'selected' : ''}
            >
              {category}
            </button>
            {selectedCategory === category && categories[category].length > 1 && (
              <div className="subcategory-dropdown">
                {categories[category].map((subcategory) => (
                  <button
                    key={subcategory}
                    onClick={() => handleSubcategoryClick(subcategory)}
                    className={selectedSubcategory === subcategory ? 'selected-sub' : ''}
                  >
                    {subcategory}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="filter-price">
        <h4>Filtriraj po ceni</h4>
        <input
          type="number"
          placeholder="Minimalna cena"
          value={minPrice}
          onChange={handleMinPriceChange}
        />
        <input
          type="number"
          placeholder="Maksimalna cena"
          value={maxPrice}
          onChange={handleMaxPriceChange}
        />
      </div>
      
      <button onClick={handleResetFilters}>Resetuj filtere</button>
    </div>
  );
}

export default FilterOptions;
